<template>
  <div>
    <TheAutonomousBanner
      bannerPageName="orders.cost-summary-drawer"
      page-level="TAB"
    />
  </div>

  <RevLoadingScreen
    v-if="pending"
    class="mt-56"
    :text="i18n(translations.loading)"
  />

  <RevCard v-if="!pending && data">
    <NoResults v-if="data.costBreakdown.length === 0" />
    <Table
      v-if="data.costBreakdown.length > 0"
      :financialDetails="data"
      :orderId="order.id"
    />
  </RevCard>
</template>

<script setup lang="ts">
import { financeSellerLedgerAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'

import type { Order } from '../../../../../../../../../../Tab.types'

import translations from './FinancialDetailsTab.translations'
import NoResults from './components/NoResults/NoResults.vue'
import Table from './components/Table/Table.vue'

const i18n = useI18n()
const props = defineProps<{ order: Order }>()

const { data, pending } = useHttpFetch(
  financeSellerLedgerAPI.getSellerOrderFinancialDetails,
  { pathParams: { orderId: props.order.id } },
)
</script>
